import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import HttpBackend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';

// i18n
//   .use(HttpBackend)
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     fallbackLng: 'en',
//     debug: true,
//     interpolation: {
//       escapeValue: false,
//     },
//     backend: {
//       loadPath: '/i18n/locals/{{lng}}/{{ns}}.json',
//     },
//   });

i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    lng: 'en',
    resources: {
      en: {
        translations: require('./locals/en/translations.json')
      },
      ba: {
        translations: require('./locals/ba/translations.json')
      },
      bg: {
        translations: require('./locals/bg/translations.json')
      },
      tr: {
        translations: require('./locals/tr/translations.json')
      },
      zh: {
        translations: require('./locals/zh/translations.json')
      },
    },
    ns: ['translations'],
    defaultNS: 'translations'
  });
  
  i18n.languages = ['en', 'ba'];
export default i18n;
